import { PageLayout } from '@reapit/elements/core/page-layout'
import React from 'react'
import { Outlet } from 'react-router'
import Topbar from '../components/topbar'

const MainLayout: React.FC = () => {
  return (
    <PageLayout id="admin-layout" scroll="body" backgroundColour="--colour-fill-white">
      <PageLayout.TopBarRegion>
        <Topbar />
      </PageLayout.TopBarRegion>
      <PageLayout.BodyRegion>
        <Outlet />
      </PageLayout.BodyRegion>
    </PageLayout>
  )
}

export default MainLayout
